// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3a8KK","title":"styles_title__3vAlo"};